import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Alert } from '@mui/material';
import useStyles from './styles';
export default function ConfirmTab(props) {
  const classes = useStyles();
  const _props$tenantsList = props.tenantsList,
    tenantsList = _props$tenantsList === void 0 ? undefined : _props$tenantsList,
    _props$buildingsList = props.buildingsList,
    buildingsList = _props$buildingsList === void 0 ? undefined : _props$buildingsList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Fee update will take place in the next billing cycle"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "The following changes will be applied on the next billing cycle. You may change them back till that time.")), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "The following residents will have their fees changed:")), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, tenantsList && /*#__PURE__*/React.createElement(React.Fragment, null, tenantsList.map(tenant => /*#__PURE__*/React.createElement("div", {
    key: tenant,
    className: classes.tenant
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, tenant)))), buildingsList && /*#__PURE__*/React.createElement(React.Fragment, null, buildingsList.map(building => /*#__PURE__*/React.createElement(React.Fragment, {
    key: building.address
  }, building.tenants.map(tenant => /*#__PURE__*/React.createElement("div", {
    key: tenant,
    className: classes.tenant
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, building.address, ": Unit ", tenant))))))));
}
ConfirmTab.propTypes = {
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};